// styles
import "../themes/common.scss";
import "../themes/css/pages/fixed-deposit.scss";
//js
import "../themes/js/common.js";
import "../themes/js/pages/fixed-deposit.js";

import { initmanage } from "../javascripts/component/manage.js";

initmanage();